<template>
	<div class="product-table">
		<p class="product-table__small-title">
			Number of order(s)/item(s) scanned into sewing
		</p>
		<table class="product-table__table">
			<thead>
				<tr>
					<th v-for="eachsummary in summary" v-bind:key="eachsummary.sku">{{ eachsummary.sku }} </th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td v-for="eachsummary in summary" v-bind:key="eachsummary.count">{{ eachsummary.count }} </td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import Vue from "vue";

import { mapActions } from "vuex";

export default Vue.extend({
	name: "ProductTable",
	components: {},
	methods: {
		...mapActions(["getData"])
	},
	computed: {
		summary: {
			get() {
				return this.$store.getters.scanSummary;
			}
		},
		
	},
	mounted() {
		this.getData();
	}
});
</script>

<style lang="scss" scoped>
.product-table {
	padding: 10px 0 20px;

	&__small-title {
		text-align: center;
		padding: 10px 0 20px;
		font-weight: 600;
		font-size: 14px;
	}

	&__table {
		margin: 0 auto;

		th,
		td {
			border: 1px solid $border-color;
			text-align: center;
			padding: 7px 0;
		}

		th {
			background-color: lighten($color7, 10%);
			font-weight: 500;
			width: 140px;
		}

		td {
			background-color: $table-light-bg;
		}
	}
}
</style>